module.exports = __webpack_public_path__ + "img/photo_guillaume.1ca241cb.png";